/* =================================================================
   Fisch aus MV – script.js
   Navigation, Scrollspy, Sticky-Header, Akkordeon, Tabs,
   Fischer-Filter, Scroll-Animationen, Back-to-top
   ================================================================= */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 1. Mobile-Navigation ---------- */
  var header = document.getElementById("header");
  var navToggle = document.getElementById("navToggle");
  var nav = document.getElementById("primaryNav");

  function closeNav() {
    nav.classList.remove("is-open");
    navToggle.setAttribute("aria-expanded", "false");
    navToggle.setAttribute("aria-label", "Menü öffnen");
  }
  function openNav() {
    nav.classList.add("is-open");
    navToggle.setAttribute("aria-expanded", "true");
    navToggle.setAttribute("aria-label", "Menü schließen");
  }

  navToggle.addEventListener("click", function () {
    if (nav.classList.contains("is-open")) { closeNav(); } else { openNav(); }
  });

  nav.addEventListener("click", function (e) {
    if (e.target.closest(".nav__link")) { closeNav(); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && nav.classList.contains("is-open")) {
      closeNav();
      navToggle.focus();
    }
  });

  /* ---------- 2. Sticky-Header (Schatten/Kompakt ab Offset) ---------- */
  function onScrollHeader() {
    header.classList.toggle("is-scrolled", window.scrollY > 30);
  }
  onScrollHeader();
  window.addEventListener("scroll", onScrollHeader, { passive: true });

  /* ---------- 2b. Home-Links auf der Startseite: scrollen statt neu laden ---------- */
  document.querySelectorAll("[data-home]").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      closeNav();
      window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
    });
  });

  /* ---------- 3. Scrollspy – aktiver Menüpunkt ---------- */
  var navLinks = Array.prototype.slice.call(nav.querySelectorAll(".nav__link"));
  var sections = navLinks
    .map(function (link) {
      return link.hash ? document.getElementById(link.hash.slice(1)) : null;
    })
    .filter(Boolean);

  function setActive(id) {
    navLinks.forEach(function (link) {
      link.classList.toggle("is-active", link.hash === "#" + id);
    });
  }

  if ("IntersectionObserver" in window && sections.length) {
    var spy = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { setActive(entry.target.id); }
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    sections.forEach(function (s) { spy.observe(s); });
  }

  /* ---------- 4. FAQ-Akkordeon (alle Akkordeons auf der Seite) ---------- */
  Array.prototype.slice.call(document.querySelectorAll(".accordion")).forEach(function (accordion) {
    var triggers = Array.prototype.slice.call(accordion.querySelectorAll(".accordion__trigger"));
    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var item = trigger.closest(".accordion__item");
        var isOpen = item.classList.contains("is-open");
        // Nur eines offen: alle anderen im selben Akkordeon schließen
        triggers.forEach(function (t) {
          t.closest(".accordion__item").classList.remove("is-open");
          t.setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          item.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
        }
      });
    });
  });

  /* ---------- 5. Tabs (Saison & Fangmethoden) ---------- */
  Array.prototype.slice.call(document.querySelectorAll("[data-tabs]")).forEach(function (group) {
    var tabs = Array.prototype.slice.call(group.querySelectorAll(".tabs__tab"));
    var panels = Array.prototype.slice.call(group.querySelectorAll(".tabs__panel"));

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute("aria-selected", selected ? "true" : "false");
        tab.tabIndex = selected ? 0 : -1;
        panels[i].classList.toggle("is-active", selected);
        if (selected) { panels[i].removeAttribute("hidden"); }
        else { panels[i].setAttribute("hidden", ""); }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () { activate(i); });
      tab.addEventListener("keydown", function (e) {
        var next;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") { next = (i + 1) % tabs.length; }
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") { next = (i - 1 + tabs.length) % tabs.length; }
        else if (e.key === "Home") { next = 0; }
        else if (e.key === "End") { next = tabs.length - 1; }
        else { return; }
        e.preventDefault();
        activate(next);
        tabs[next].focus();
      });
    });
  });

  /* ---------- 6. Fischer-Übersicht: "mehr anzeigen" ---------- */
  var fisherGrid = document.getElementById("fisherGrid");
  var fisherMore = document.getElementById("fisherMore");

  if (fisherGrid) {
    var cards = Array.prototype.slice.call(fisherGrid.querySelectorAll(".fisher-card"));
    var STEP = 3;
    var visibleCount = STEP;

    function renderFishers() {
      cards.forEach(function (card, i) { card.hidden = i >= visibleCount; });
      if (fisherMore) { fisherMore.hidden = cards.length <= visibleCount; }
    }

    if (fisherMore) {
      fisherMore.addEventListener("click", function () {
        visibleCount += STEP;
        renderFishers();
      });
    }

    renderFishers();
  }

  /* ---------- 6b. Fisch-Karten aufklappen (Touch) ---------- */
  var fishGrid = document.querySelector(".fish-grid");
  if (fishGrid) {
    fishGrid.addEventListener("click", function (e) {
      var toggle = e.target.closest("[data-fish-toggle]");
      if (!toggle) { return; }
      var card = toggle.closest(".fish-card");
      var isOpen = card.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  /* ---------- 7. Scroll-Animationen ---------- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll(".reveal"));
  if (reduceMotion || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  } else {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.1 }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- 8. Back-to-top ---------- */
  var toTop = document.getElementById("toTop");
  if (toTop) {
    window.addEventListener("scroll", function () {
      toTop.classList.toggle("is-visible", window.scrollY > 600);
    }, { passive: true });

    toTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
    });
  }

  /* ---------- 9. Newsletter: echtes Shopify-Formular ({% form 'customer' %}),
     keine JS-Absendung mehr – native Submission + serverseitige Erfolgs-/Fehlermeldung. ---------- */

  /* ---------- 10. Steckbrief: Standort-Filter + "Jetzt geöffnet" ---------- */
  var locationGrid = document.getElementById("locationGrid");

  if (locationGrid) {
    var locCards = Array.prototype.slice.call(locationGrid.querySelectorAll(".loc-card"));

    // Minuten seit Mitternacht aus "HH:MM" oder "HH"; NaN, wenn nicht parsebar
    function toMinutes(hhmm) {
      var t = String(hhmm).trim();
      if (!/^\d{1,2}(:\d{1,2})?$/.test(t)) { return NaN; }
      var p = t.split(":");
      var h = parseInt(p[0], 10);
      var m = p.length > 1 ? parseInt(p[1], 10) : 0;
      if (h > 23 || m > 59) { return NaN; }
      return h * 60 + m;
    }

    // Status des Standorts für HEUTE:
    //   "open"   = jetzt geöffnet
    //   "closed" = gültige Zeiten, aber gerade zu
    //   null     = keine gültige/parsebare Zeitspanne -> kein Status anzeigen
    function dayStatus(card) {
      var raw = card.getAttribute("data-hours") || "";
      var days = raw.split("|");
      var now = new Date();
      var idx = (now.getDay() + 6) % 7; // Mo=0 … So=6
      var seg = (days[idx] || "").trim();
      if (seg.indexOf("-") === -1) { return null; }
      var parts = seg.split("-");
      var start = toMinutes(parts[0]);
      var end = toMinutes(parts[1]);
      if (isNaN(start) || isNaN(end)) { return null; }
      var cur = now.getHours() * 60 + now.getMinutes();
      return (cur >= start && cur < end) ? "open" : "closed";
    }

    // Status-Pille je Karte setzen (immer, auch ohne Filterleiste).
    // Nicht bestimmbar -> Pille bleibt ausgeblendet (weder offen noch geschlossen).
    locCards.forEach(function (card) {
      var badge = card.querySelector("[data-status]");
      if (!badge) { return; }
      var st = dayStatus(card);
      if (st === null) { badge.hidden = true; return; }
      badge.hidden = false;
      badge.textContent = st === "open" ? "Jetzt geöffnet" : "Geschlossen";
      badge.classList.add(st === "open" ? "is-open" : "is-closed");
    });

    // Filter nur, wenn die Filterleiste existiert (ab 2 Standorten)
    var locationFilter = document.getElementById("locationFilter");
    if (locationFilter) {
      var locationEmpty = document.getElementById("locationEmpty");
      var currentSpecies = "alle";
      var openNowOnly = false;

      var renderLocations = function () {
        var visible = 0;
        locCards.forEach(function (card) {
          var speciesOk = currentSpecies === "alle" || card.getAttribute("data-species") === currentSpecies;
          var openOk = !openNowOnly || dayStatus(card) === "open";
          var show = speciesOk && openOk;
          card.hidden = !show;
          if (show) { visible++; }
        });
        if (locationEmpty) { locationEmpty.hidden = visible !== 0; }
      };

      locationFilter.addEventListener("click", function (e) {
        var btn = e.target.closest(".filter__btn");
        if (!btn) { return; }

        if (btn.hasAttribute("data-open-now")) {
          openNowOnly = !openNowOnly;
          btn.setAttribute("aria-pressed", openNowOnly ? "true" : "false");
        } else {
          locationFilter.querySelectorAll(".filter__btn:not([data-open-now])").forEach(function (b) {
            b.classList.remove("is-active");
          });
          btn.classList.add("is-active");
          currentSpecies = btn.getAttribute("data-species");
        }
        renderLocations();
      });

      renderLocations();
    }
  }

  /* ---------- 11. Steckbrief: Galerie-Lightbox ---------- */
  var sbGallery = document.getElementById("sbGallery");
  var sbLightbox = document.getElementById("sbLightbox");

  if (sbGallery && sbLightbox) {
    var lbImg = document.getElementById("sbLightboxImg");
    var lbClose = document.getElementById("sbLightboxClose");
    var lbPrev = document.getElementById("sbLightboxPrev");
    var lbNext = document.getElementById("sbLightboxNext");
    var galleryImgs = Array.prototype.slice.call(sbGallery.querySelectorAll("img"));
    var lbIndex = 0;
    var lastFocused = null;

    function showImage(i) {
      lbIndex = (i + galleryImgs.length) % galleryImgs.length;
      var src = galleryImgs[lbIndex];
      // größtmögliche Variante laden (Shopify liefert width als Query-Param)
      lbImg.src = src.currentSrc || src.src;
      lbImg.alt = src.alt || "";
    }

    function openLightbox(i) {
      lastFocused = document.activeElement;
      showImage(i);
      sbLightbox.hidden = false;
      document.body.style.overflow = "hidden";
      lbClose.focus();
    }

    function closeLightbox() {
      sbLightbox.hidden = true;
      document.body.style.overflow = "";
      if (lastFocused) { lastFocused.focus(); }
    }

    sbGallery.addEventListener("click", function (e) {
      var item = e.target.closest("[data-lightbox]");
      if (!item) { return; }
      var items = Array.prototype.slice.call(sbGallery.querySelectorAll("[data-lightbox]"));
      openLightbox(items.indexOf(item));
    });

    lbClose.addEventListener("click", closeLightbox);
    lbPrev.addEventListener("click", function () { showImage(lbIndex - 1); });
    lbNext.addEventListener("click", function () { showImage(lbIndex + 1); });
    sbLightbox.addEventListener("click", function (e) {
      if (e.target === sbLightbox) { closeLightbox(); }
    });
    document.addEventListener("keydown", function (e) {
      if (sbLightbox.hidden) { return; }
      if (e.key === "Escape") { closeLightbox(); }
      else if (e.key === "ArrowLeft") { showImage(lbIndex - 1); }
      else if (e.key === "ArrowRight") { showImage(lbIndex + 1); }
    });
  }
})();
